/**
 * Entry point. Order matters: we configure Amplify BEFORE React mounts
 * so the first render sees a configured Auth module.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { configureAmplify } from '@/lib/amplify';
import { initAnalytics } from '@/lib/analytics';

import { App } from './app/app';

import '@/styles/tokens.css';

configureAmplify();
initAnalytics();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Missing #root element in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
